import Table from "./Table";

const List = ({ data, groupId }) => {
	return <Table data={data} groupId={groupId} />;
};

export default List;
